<template>

  <v-select
      prepend-icon="view_stream"
      :items="items"
      v-model="item"
      :label="$t('afip.factura.labels.CondicionIVAReceptor')"
      :loading="loading"
      :error="hasInputErrors('CondicionIVAReceptor')"
      :error-messages="getInputErrors('CondicionIVAReceptor')"
      color="secondary"
      item-color="secondary"
      :clearable="clearable"
      :multiple="multiple"
      :chips="chips"
      :solo="solo"
  ></v-select>

</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


export default {
  name: "CondicionIvaCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {type: [String, Array]},
    clearable: {type: Boolean, default: false},
    multiple: {type: Boolean, default: false},
    solo: {type: Boolean, default: false},
    chips: {type: Boolean, default: false}
  },
  data() {
    return {
      items: [
        'IVA Responsable Inscripto',
        'IVA Sujeto Exento',
        'Consumidor Final',
        'Responsable Monotributo',
        'Sujeto No Categorizado',
        'Proveedor del Exterior',
        'Cliente del Exterior',
        'IVA Liberado - Ley Nº 19.640',
        'Monotributista Social',
        'IVA No Alcanzado',
        'Monotributista Trabajador Independiente Promovido',
      ],
      loading: false
    }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    }
  }
}
</script>

<style scoped>

</style>

